import {Component, OnInit, Input, OnDestroy, ViewChild, EventEmitter, Output} from '@angular/core';
import {CropActions} from "../actions/crop.actions";
import {NgRedux} from "ng2-redux";

import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/skipWhile';
import {OptionsActions} from "../actions/options.actions";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {isNullOrUndefined} from "util";
import {ImageProfile} from "../../../../+admin/+users/users.service";


require('jquery-jcrop/js/jquery.Jcrop.min.js');

const debounce = require('debounce');

@Component({
  selector: 'jcrop',
  template: `
      <div style="width: 100%; padding: 10px">
          <span class="ticket-icon-plus" (click)="zoom()"></span>
          <button (click)="saveImage()" style="width: 150px" class="btn roundButton borde-rosa">Guardar</button>
      </div>
    <div style="margin-right: 20px; overflow: auto;height: calc(100% - 30px);width: 100%;" #jcropContainer 
         [ngStyle]="{width: width + 'px',height: height + 'px'}">
        <img #jcropImage id="source" [src]="src" [width]="width" [height]="height" />
    </div>
      <canvas id="canvas"></canvas>
  `,

})
export class JcropComponent implements OnInit, OnDestroy {

  @Input() src: any;
  @Input() width: number;
  @Input() height: number;
  @Input() storeId: any;


  @ViewChild('jcropImage') jcropImage;
  @ViewChild('jcropContainer') jcropContainer;

  @Input() options: any;

  private api: any;

  private lastOptions: any = {};
  private optionsSub: any;

  private lastCrop: any = {};
  private cropSub: any;
  private isMoving: boolean = false;
  private isActive: boolean = false;
  public imageProfile:ImageProfile = new ImageProfile();

  @Output()
  public onImageResult:EventEmitter<any> = new EventEmitter();

  constructor(private ngRedux: NgRedux<any>,
              private cropActions: CropActions,
              private domSn: DomSanitizer,
              private optionsActions: OptionsActions,) {
  }

  ngOnInit() {

    let self = this;

    this.optionsSub = this.ngRedux.select([this.storeId, 'options'])

      .subscribe((options: any) => {
        if (!this.api) return;
        let updates = Object.keys(options).reduce((_updates, key)=> {
          if (this.lastOptions[key] != options[key]) {
            _updates[key] = options[key]
          }
          return _updates
        }, {});

        if (options.setImage) {
          options.src = options.setImage;
          self.api.disable();

          self.api.setImage(options.setImage);
          self.api.enable();
        }

        if (Object.keys(updates).length) {
          self.api.setOptions(updates);
          self.api.focus();
        }


        self.lastOptions = Object.assign({}, options)


      });


    this.cropSub = this.ngRedux.select([this.storeId, 'crop', 'selection']).skipWhile(() => {
      return self.isMoving
    }).subscribe((crop: any)=> {
      if (!self.api) return;

      let options = self.ngRedux.getState()[self.storeId].options;

      let lc = self.lastCrop;


      if (
        crop &&
        crop.x &&
        crop.y &&
        crop.x2 &&
        crop.y2 && !self.isMoving &&
        (
          lc.x != crop.x ||
          lc.y != crop.y ||
          lc.x2 != crop.x2 ||
          lc.y2 != crop.y2
        )
      ) {
        self.lastCrop = Object.assign({}, crop);

        self.isMoving = true;
        if (options.animateTo) {
          self.api.animateTo([crop.x, crop.y, crop.x2, crop.y2], function () {
            self.isMoving = false
          });
        } else {
          self.api.setSelect([crop.x, crop.y, crop.x2, crop.y2]);
          self.isMoving = false
        }
      }
    });

    this.render()
  }

  public currentWidth:number;

  render() {

    const self = this;
    const element = jQuery(this.jcropImage.nativeElement);
    const container = jQuery(this.jcropContainer.nativeElement);

    element.Jcrop({
      onChange: this.onChange,
      onSelect: this.onSelect,
      onRelease: this.onRelease,
    }, function () {
      console.log(`Starting crop`);
      self.api = this;


      this.currentWidth = self.width;

      let initializingOptions = Object.assign({}, {
        width: self.width,
        height: self.height,
        src: self.src,
      }, self.options || {})


      if(initializingOptions.setSelect){
        self.cropActions.cropSelect(initializingOptions.setSelect, self.storeId)
      } else {
        self.cropActions.cropRandomSelection(self.storeId)
      }

      self.optionsActions.setOptions({
        options: initializingOptions,
        storeId: self.storeId
      })

    });
  }

  onChange = (crop)=> {
    this.cropActions.cropChange(
      crop, this.storeId
    )
  };

  onSelect = (crop)=> {
    this.cropActions.cropSelect(
      crop, this.storeId
    )
      console.log(`Crop selected `,crop);
    this.cropImage(crop);
  };
  onRelease = (crop)=> {
      console.log(`Crop selected `,crop);
    this.isActive = false;
      this.cropImage(crop);
  };

  public img:any;
  cropImage(crop:any) {

      let imgObject = new Image();
      if(this.src.changingThisBreaksApplicationSecurity)
        imgObject.src = this.src.changingThisBreaksApplicationSecurity;
      else imgObject.src  = this.src;

      let canvas:any = document.getElementById("canvas");
      let ctx = canvas.getContext('2d');
      ctx.canvas.width  = crop.w;
      ctx.canvas.height = crop.h;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      let image = document.getElementById('source');

      console.log("cropped", crop);
      ctx.drawImage(image, crop.x, crop.y, crop.w, crop.h, 0, 0, crop.w, crop.h);

      let imageUrl = canvas.toDataURL().split(",");
      this.img = {contentType:imageUrl[0].replace("data:","").replace(";base64",""),base64:imageUrl[1]}

  }

  saveImage() {
      this.onImageResult.emit(this.img);
  }

  zoom() {
      let image = document.getElementById('source');
      console.log(image.clientWidth);
      $('#source').css({width: '+=100px', height: '+100px'})
  }

  ngOnDestroy() {
    this.optionsSub.unsubscribe();
    this.cropSub.unsubscribe();
  }

}
